import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../Jobs/Jobs.css';

const Jobs = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const category = params.get('category');
  const subcategory = params.get('subcategory');

  const allJobs = [
    {
        id: 1,
        jobTitle: "Salesforce Developer",
        category: "IT",
        subcategory: "Software Development",
        details: {
            jobRole: "Salesforce Development",
            mandatorySkills: "Apex: 3+ years, Salesforce: 3+ years, Lightning Components (Aura), LWC: 3 years, VF Pages: 3 years, Salesforce APIs (SOAP, REST, Bulk API), Integration Patterns, PD1 (Platform Developer I)",
            experience: "3+ years experience mandatory",
            salary: "",
            extraBenefits: [],
            shiftTimeAndWeekOff: "",
            communication: "",
            transportFacility: "",
            immediateJoiner: ""
        }
    },
    {
        id: 2,
        jobTitle: "Customer Service",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: "Customer Service",
            experience: "Open to both freshers and experienced candidates",
            salary: "₹28,500 CTC to ₹40,000",
            extraBenefits: [],
            shiftTimeAndWeekOff: "Rotational Shift (Day shift for females until 9 PM; Rotational for males)",
            communication: "Excellent communication skills in both English and Hindi. No Mother Tongue Influence (MTI) or Regional Tongue Influence (RTI), and no grammatical or pronunciation errors.",
            transportFacility: "",
            immediateJoiner: "",
            other: {
                position: "L1",
                location: "Kharadi, Pune",
                education: "Graduate in any field",
                writingSkills: "Strong Hindi writing skills",
                certification: "Veti 6 certified",
                preferred: "Insurance experience and sales acumen"
            }
        }
    },
    {
        id: 3,
        jobTitle: "Customer Service Associate (Voice)",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: "Customer Care, Non-Voice",
            qualification: ["HSC", "Graduate"],
            salary: {
                ctc: "15K",
                inHand: "12.6K"
            },
            extraBenefits: ["Incentives", "Over Time (we pay the highest over time)"],
            shiftTimeAndWeekOff: "6 Days working 24*7 Rotational Shifts (Including Night Shifts). 1 Rotational Week Off.",
            communication: "Fluent English Communication",
            transportFacility: "Pick-up or Drop facility available (One side transport available)",
            immediateJoiner: "prefered"
        }
    },
    {
        id: 4,
        jobTitle: "Customer Service Associate (Voice)",
        category: "Non IT",
        subcategory: "BPO",
        details: {
            jobRole: ["Ticket booking, cancellation, Flight delays", "Solving queries related to Refund and baggage's", "Informing customers related to the flights"],
            qualification: ["HSC", "Graduate"],
            salary: {
                ctc: "15K",
                inHand: "12.6K"
            },
            extraBenefits: ["Incentives", "Over Time (we pay the highest over time)"],
            shiftTimeAndWeekOff: "6 Days working 24*7 Rotational Shifts (Including Night Shifts). 1 Rotational Week Off.",
            communication: "Fluent English Communication",
            transportFacility: "Pick-up or Drop facility available (One side transport available)",
            immediateJoiner: ""
        }
    }
  ];

  const [filteredJobs, setFilteredJobs] = useState([]);

  useEffect(() => {
    // Filter jobs based on category and subcategory
    const jobs = allJobs.filter((job) => {
      return job.category === category && (!subcategory || job.subcategory === subcategory);
    });
    setFilteredJobs(jobs);
  }, [category, subcategory]);


  const handleApply = (jobTitle) => {
    const email = "hr@shritechs.in";
    const subject = `Application for ${jobTitle}`;
    const body = "Dear Hiring Team,\n\nI am interested in applying for the position of " + jobTitle + ".\n\nBest regards,\n[Your Name]";
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (

    <>  <div className="container">
    <header>
      <h1>Job Openings</h1>
    </header>
    <div className="jobs-section">
      <p>Category: {category}</p>
      <p>Subcategory: {subcategory}</p>

      {filteredJobs.length > 0 ? (
        <div className="job-list">
          {filteredJobs.map((job) => (
            <div key={job.id} className="job-item">
              <h2>{job.jobTitle}</h2>
              <p><strong>Category:</strong> {job.category}</p>
              <p><strong>Subcategory:</strong> {job.subcategory}</p>

              <h3>Details:</h3>
              {job.details && (
                <div>
                  {job.details.mandatorySkills && (
                    <div>
                      <h4>Mandatory Skills:</h4>
                      <p>{job.details.mandatorySkills}</p>
                    </div>
                  )}

                  {job.details.experience && (
                    <p>
                      <strong>Experience:</strong> {job.details.experience}
                    </p>
                  )}

                  {job.details.position && (
                    <p><strong>Position:</strong> {job.details.position}</p>
                  )}

                  {job.details.location && (
                    <p><strong>Location:</strong> {job.details.location}</p>
                  )}

                  {job.details.salary && (
                    <div>
                      <h4>Salary:</h4>
                      {typeof job.details.salary === 'object' ? (
                        <ul>
                          {Object.entries(job.details.salary).map(([key, value]) => (
                            <li key={key}>
                              <strong>{key}:</strong> {value}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p>{job.details.salary}</p>
                      )}
                    </div>
                  )}

                  {job.details.shift && (
                    <p><strong>Shift:</strong> {job.details.shift}</p>
                  )}

                  {job.details.requirements && (
                    <div>
                      <h4>Requirements:</h4>
                      <ul>
                        {Object.entries(job.details.requirements).map(([key, value]) => (
                          <li key={key}>
                            <strong>{key}:</strong> {value.toString()}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {job.details.company && (
                    <p><strong>Company:</strong> {job.details.company}</p>
                  )}

                  {Array.isArray(job.details.jobRole) ? (
                    <div>
                      <h4>Job Role:</h4>
                      <ul>
                        {job.details.jobRole.map((role, index) => (
                          <li key={index}>{role}</li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    <p><strong>Job Role:</strong> {job.details.jobRole}</p>
                  )}

                  {job.details.qualification && (
                    <div>
                      <h4>Qualification:</h4>
                      <ul>
                        {job.details.qualification.map((qual, index) => (
                          <li key={index}>{qual}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {job.details.extraBenefits && (
                    <div>
                      <h4>Extra Benefits:</h4>
                      <ul>
                        {job.details.extraBenefits.map((benefit, index) => (
                          <li key={index}>{benefit}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {job.details.shiftTimeAndWeekOff && (
                    <p><strong>Shift Time & Week Off:</strong> {job.details.shiftTimeAndWeekOff}</p>
                  )}

                  {job.details.communication && (
                    <p><strong>Communication:</strong> {job.details.communication}</p>
                  )}

                  {job.details.transportFacility && (
                    <p><strong>Transport Facility:</strong> {job.details.transportFacility}</p>
                  )}

                  {job.details.immediateJoiner && (
                    <p><strong>Immediate Joiner:</strong> {job.details.immediateJoiner ? "Yes" : "No"}</p>
                  )}
                </div>
              )}

              <button className="apply-button" onClick={() => handleApply(job.jobTitle)} >Apply Now</button>
            </div>
          ))}
        </div>
      ) : (
        <p>No jobs found for the selected category and subcategory.</p>
      )}
    </div>
  </div>
    </>
   
  );
};

export default Jobs;
